<template>
  <div>
    <v-tabs background-color="primary" dark>
      <v-tab
        v-for="route in routes"
        :key="route.name"
        :to="{ name: route.name }"
      >
        {{ route.meta.label }}
      </v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import { SupportRoutes } from '@/router/superadmin'

export default {
  name: 'SupportMainSuperAdmin',
  computed: {
    routes() {
      return SupportRoutes.children || []
    }
  }
}
</script>